export const isRecentAction = (date) => {
  const currentDate = Date.now();
  return currentDate - date <= 60 * 4 * 1000;
};
export const byPenalty = e =>
  (e.penalties.accelerating && +e.penalties.accelerating.penalty !== 0) ||
  (e.penalties.braking && +e.penalties.braking.penalty !== 0) ||
  (e.penalties.cornering && +e.penalties.cornering.penalty !== 0) ||
  (e.penalties.speeding && +e.penalties.speeding.penalty !== 0);

export const coupleEvents = events =>
  events
    .sort((e1, e2) => e2.occurrenceTime - e1.occurrenceTime)
    .reduce((set, e, i) => {
      if (e.penalties && e.penalties.speeding) {
        set.currentLine.push(e);
        if (i === set.lastIndex && set.currentLine.length > 0) {
          set.currentLine.push(e);
          set.lines.push(set.currentLine);
        }
      } else if (set.currentLine.length > 0) {
        set.currentLine.push(e);
        set.lines.push(set.currentLine);
        set.currentLine = [];
      }
      return set;
    }, {
      currentLine: [],
      currentI: 0,
      lines: [],
      lastIndex: events.length - 1,
    })
    .lines;

export const getEventType = (penalties) => {
  const types = ['Acceleration', 'Braking', 'Cornering', 'Speeding'];
  if (penalties.speeding) return types[3];
  if (penalties.cornering) return types[2];
  if (penalties.braking) return types[1];
  if (penalties.accelerating) return types[0];
  return 'Unknown';
};

export const formatNumber = (number, size) => {
  let s = `${number}`;
  while (s.length < size) s = `0${s}`;
  return s;
};

export const createRange = (start, end) => Array.from({length: (end - start)}, (v, k) => k + start)



// WEBPACK FOOTER //
// ./src/utils/helpers.js